/* Scroll-triggered count-up for .product-hero-stats__stat (transferred verbatim from
   the live Replo page): ease-out cubic, 1.8s duration, 0.3s stagger delay. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateCount(el, end, duration) {
    const start = 0;
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(start + eased * (end - start));
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  const stats = document.querySelectorAll('.product-hero-stats__stat');
  if (!stats.length) return;

  if (reducedMotion.matches) {
    stats.forEach((stat) => {
      stat.classList.add('is-visible');
      const countEl = stat.querySelector('[data-stats-count-target]');
      if (countEl) countEl.textContent = stat.dataset.statsCount;
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !entry.target.dataset.statsCounted) {
          entry.target.classList.add('is-visible');
          entry.target.dataset.statsCounted = 'true';
          const target = parseInt(entry.target.dataset.statsCount, 10);
          const countEl = entry.target.querySelector('[data-stats-count-target]');
          if (countEl && !Number.isNaN(target)) {
            setTimeout(() => animateCount(countEl, target, 1800), 300);
          }
        }
      });
    },
    { threshold: 0.3 }
  );

  stats.forEach((stat) => observer.observe(stat));
})();
